import React, { FC, useState, useCallback } from 'react'

import { colors } from '../../theme'
import CardCarousel, { CardCarouselProps } from '../CardCarousel'
import { ECollapsable } from '../Collapsable/types'

import * as SC from './styled'

export type RecipesHighlightSectionProps = {
  className?: string
  carouselName?: string
  cards?: CardCarouselProps['cards']
  title?: string
  description?: string
  maxChars?: number
  seeMoreText?: string
  seeLessText?: string
}

const RecipesHighlightSection: FC<RecipesHighlightSectionProps> = (props) => {
  const {
    className,
    carouselName,
    cards,
    title,
    description,
    seeMoreText,
    seeLessText,
  } = props

  const [isSeeMoreOpen, setIsSeeMoreOpen] = useState<boolean>(false)
  const onSeeMoreHandler = useCallback(() => {
    setIsSeeMoreOpen(!isSeeMoreOpen)
  }, [isSeeMoreOpen])
  return (
    <SC.WrapperCollapsable
      className={className}
      isCollapsable={ECollapsable.NONE}
      backgroundColor={colors.greyf5}
      isOpenOnInit
    >
      <SC.Inner>
        {cards && (
          <SC.Carousel>
            <CardCarousel name={carouselName} cards={cards} />
          </SC.Carousel>
        )}
        <SC.Introduction>
          {title && <SC.Title>{title}</SC.Title>}
          {description && (
            <SC.Description $showMore={isSeeMoreOpen}>
              {description}
            </SC.Description>
          )}
          {description && (
            <SC.SeeMore onClickHandler={onSeeMoreHandler}>
              {isSeeMoreOpen ? seeLessText : seeMoreText}
            </SC.SeeMore>
          )}
        </SC.Introduction>
      </SC.Inner>
    </SC.WrapperCollapsable>
  )
}

export default RecipesHighlightSection
